var _process;

try{
  _process = eval('process');
}catch(e){
  // No process variable
}

module.exports = typeof _process === 'object' && _process.toString() === '[object process]';



//////////////////
// WEBPACK FOOTER
// ./node_modules/jpex/src/isNode.js
// module id = 3aNn
// module chunks = 0